export const ELEMENT_MULTI_COL = 'multi_col';

export const ELEMENT_COL = 'col';
